import { Component, ErrorInfo } from 'react'

import { reportError } from 'utils/error'
import { showErrorMessageToast } from 'common/MessageToasts/ErrorMessageToast/ErrorMessageToast'

export class LazyErrorBoundary extends Component<{ children?: any }, {}> {
  componentDidCatch(error: Error, info: ErrorInfo) {
    if (error.name !== 'ChunkLoadError' && (error as Error & { code?: string }).code !== 'CSS_CHUNK_LOAD_FAILED')
      throw error

    reportError(error.message, { severity: 'error', metaData: { info } })

    showErrorMessageToast('Your internet connection appears to be offline. Please try again.')
  }

  render() {
    return this.props.children
  }
}
